import { Modal } from 'antd'
import type { IToastProps } from '@/app/components/base/toast'
import i18next from 'i18next'

export type IOnAction = {
  setLoading: (loading: boolean) => void
  action?: () => Promise<any>
  notify?: (props: IToastProps) => void
  mutate?: () => void
  actionName: string
  confirm?: boolean
  onSuccess?: () => void
  onError?: () => void
}

export const onAction = ({
  setLoading,
  action,
  notify = () => {},
  mutate = () => {},
  actionName,
  confirm = false,
  onSuccess = () => { },
  onError = () => { },
}: IOnAction) => {
  const t = i18next.t.bind(i18next)
  const _action = () => {
    setLoading(true)
    action?.()
      .then(() => {
        notify({ type: 'success', message: t('common.action.success', { actionName }) })
        mutate()
        onSuccess()
      })
      .catch(() => {
        notify({ type: 'error', message: t('common.action.fail', { actionName }) })
        onError()
      })
      .finally(() => {
        setLoading(false)
      })
  }
  if (confirm) {
    Modal.confirm({
      title: t('common.action.confirm_title', { actionName }),
      content: t('common.action.confirm_content', { actionName }),
      okText: t('common.operation.confirm'),
      cancelText: t('common.operation.cancel'),
      onOk: _action,
    })
  } else {
    _action()
  }
}
